const workplan = [
  {
    id: 1,
    title: "1. Regional Database and Gazetteer Standards",
    description:
      "Achieve standardized database and gazetteer in ASE region for data exchange and publication.",
    items: [
      {
        year: "2023",
        text: "Review the existing database and gazetteer standard",
      },
      {
        year: "2024",
        text: "Evaluation of the database and gazetteer standard",
      },
      {
        year: "2025",
        text: "Adoption of the database and gazetteer standard",
      },
      {
        year: "2026",
        text: "Publish the guideline database and gazetteer standard",
      },
    ],
  },
  {
    id: 2,
    title: "2. UNGEGN ASE Division Annual Meetings",
    description:
      "Maintain the connection and collaboration for data exchange and knowledge sharing amongst ASED member countries in the field of geographical names.",
    items: [
      {
        year: "2022",
        text:
          "• Update contact information for each ASE Division member country.\n• 11th Divisional Meeting of the UNGEGN ASE Division",
      },
      {
        year: "2023",
        text:
          "• 12th Divisional Meeting of the UNGEGN ASE Division in June 2023 in Bali as training side event\n• 3rd Session of the UNGEGN, 1-5 May 2023, New York\n• International training on Toponymy in June 2023, Bali\n• 13th Divisional Meeting of the UNGEGN ASE Division in November 2023 in Brunei Darussalam",
      },
      {
        year: "2024",
        text:
          "• 14th Divisional Meeting of the UNGEGN ASE Division in member country",
      },
      {
        year: "2025",
        text:
          "• 15th Divisional Meeting of the UNGEGN ASE Division in member country\n• 4th Session of the UNGEGN, New York",
      },
      {
        year: "2026",
        text:
          "• 16th Divisional Meeting of the UNGEGN ASE Division in member country\n• Election of new chairperson",
      },
    ],
  },
  {
    id: 3,
    title: "3. Regional Map of ASED Members",
    description:
      "Update the UNGEGN Regional Map of ASE Division including thematic layers such as languages, islands, and administrative boundaries.",
    items: [
      {
        year: "2023",
        text:
          "• Review the current regional map\n• Request and compile data and information from member countries",
      },
      {
        year: "2024",
        text:
          "Draft the UNGEGN Regional Map of ASED for review by all member countries",
      },
      {
        year: "2025",
        text:
          "Final version of the UNGEGN Regional Map of ASED",
      },
      {
        year: "2026",
        text:
          "Publish and distribute the Regional Map of ASE Division",
      },
    ],
  },
  {
    id: 4,
    title: "4. Generic Terms",
    description:
      "Enrich the glossary of generic terms used in Asia South East Region.",
    items: [
      {
        year: "2023",
        text:
          "Update the existing generic terms of the ASE Region",
      },
      {
        year: "2024",
        text:
          "Annual publication of the updated generic terms",
      },
      {
        year: "2025",
        text:
          "Annual publication of the updated generic terms",
      },
      {
        year: "2026",
        text:
          "Annual publication of the updated generic terms",
      },
    ],
  },
];

export default workplan;
